import { makeStyles, withStyles } from "@material-ui/core";
import { LinearProgress } from "@material-ui/core";

export const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 20,
    borderRadius: 0,
  },
  colorPrimary: {
    borderRadius: "0 10px 10px 0",
    backgroundColor: theme.custom.color.gainsboro,
  },
  bar: {
    borderRadius: "0 10px 10px 0",
    backgroundColor: theme.custom.color.apple,
  },
}))(LinearProgress);

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: "relative",
  },
  label: {
    position: "absolute",
    top: "50%",
    left: "4px",
    transform: "translateY(-50%)",
    display: "block",
    color: theme.custom.color.white,
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "0.58px",
    fontWeight: "bold",
  },
}));
